const dateOrder = (value) => {
    const text = String(value ?? "").trim()
    const br = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(text)
    const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text)
    if (!br && !iso) return Infinity

    const [year, month, day] = br ? [Number(br[3]), Number(br[2]), Number(br[1])] : iso.slice(1).map(Number)
    const date = new Date(year, month - 1, day)
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return Infinity
    return year * 10000 + month * 100 + day
}

export const sortTableItemsByDate = (items, {dateKey, idKey}) =>
    items.map((item, index) => ({item, index, date: dateOrder(item?.[dateKey])}))
        .sort((a, b) => {
            if (a.date !== b.date) return a.date - b.date
            if (a.date !== Infinity) {
                const aId = a.item?.[idKey]
                const bId = b.item?.[idKey]
                const aNumeric = /^\d+$/.test(String(aId ?? ""))
                const bNumeric = /^\d+$/.test(String(bId ?? ""))
                if (aNumeric !== bNumeric) return aNumeric ? -1 : 1
                if (aNumeric) {
                    const diff = Number(aId) - Number(bId)
                    if (diff) return diff
                }
            }
            return a.index - b.index
        })
        .map(({item}) => item)
